<template>
    <q-dialog v-model="is_open">
        <q-card v-if="isSubtreeMode || (object && canShare)">
            <q-card-section>
                <div class="text-h6" v-if="isSubtreeMode">
                    Compartir "{{ parent_name }}" ({{ nodes.length }} elemento{{ nodes.length === 1 ? '' : 's' }})
                </div>
                <div class="text-h6" v-else>
                    Share {{ object.type_name }}: {{ object.name }}
                    <!-- x button at top right -->
                </div>
            </q-card-section>
            <q-card-section>
                    <SelectField
                        v-if="canFilterByCompany"
                        v-model="company_filter"
                        label="Filter by company: "
                        :options="companyOptions"
                        :object="object"
                        option-label="label"
                        option-value="value"
                        class="q-mb-md"
                    ></SelectField>
                <!-- {{ shareOptions }} -->
                    <SelectField
                        v-model="share_targets"
                        label="Search and share to: "
                        :options="shareOptions"
                        :object="object"
                        option-label="label"
                        option-value="value"
                        :multiple="true"
                    ></SelectField>
                    <!-- <q-select
                        v-model="access"
                        label="Access"
                        :options="[ {label: 'Read', value: 'r'}, {label: 'Read/Write', value: 'w'}]"
                        emit-value
                        map-options
                    ></q-select> -->
                    <!-- Change to radioo -->
                    <q-radio v-model="access" label="Read/Write" val="w" v-if="displayedAccessOptions.includes('w')" />
                    <q-radio v-model="access" label="Read" val="r" v-if="displayedAccessOptions.includes('r')" />
                    <q-radio v-model="access" label="Execute" val="e" v-if="displayedAccessOptions.includes('e')" />
                    <div v-if="isSubtreeMode" class="text-caption text-grey-7 q-mt-sm">
                        Los elementos de tipo "Proceso" se compartirán automáticamente con acceso de Ejecución.
                    </div>

            </q-card-section>
            <q-card-actions align="right">
                <q-btn v-if="!isSubtreeMode" label="Manage Object Access" @click="redirectManage" color="secondary" icon="manage_accounts" />
                <q-btn label="Close" @click="close" />
                <q-btn label="Share" color="primary" @click="postShare" :disabled="!hasTargets" :loading="share_loading" />
            </q-card-actions>
        </q-card>
        <q-card v-else-if="object_loading">
            <q-card-section>
                Loading...
            </q-card-section>
        </q-card>
        <q-card v-else-if="!canShare">
            <q-card-section>
                Object can only be shared by owner:
                {{ users.filter(user => user.id == object?.owner_id)[0]?.username || `Unknown User - ${object?.owner_id}` }}
                <q-btn v-if="user.is_superuser || user.is_company_admin" label="Manage Object" @click="redirectObject" color="secondary" icon="manage_accounts" />
            </q-card-section>
        </q-card>
        <q-card v-else>
            <q-card-section>
                Object not found.
            </q-card-section>
        </q-card>
        
    </q-dialog>        
</template>
<script>
import { Auth } from '@/database'
import { mapGetters, mapActions } from 'vuex'
import SelectField from '../SettingTables/RowEditors/SelectField.vue'

export default {
    name: 'ShareDialog',
    components: {
        SelectField,
    },
    props: {
        object_type: Number,
        related_id_int: {
            type: Number,
            required: false,
        },
        related_id_uuid: {
            type: String,
            required: false,
        },
        allowed_access: {
            type: Array,
            required: false,
            default: () => ['r','w']
        },
        // When set, the dialog shares every node in this list at once (e.g. "share whole parent menu")
        // instead of the single object_type/related_id_* props above.
        nodes: {
            type: Array,
            required: false,
            default: null,
        },
        parent_name: {
            type: String,
            required: false,
            default: '',
        },
    },
    data(){
        return {
            is_open: false,
            // object_type: 1,
            // related_id_int: 2,
            // related_id_uuid: null,
            object: null,
            share_targets: null,
            access: 'w',
            share_loading: false,
            object_loading: true,
            company_filter: null,
        }
    },
    async created(){


    },
    methods: {
        ...mapActions(['getRoles','getUsers', 'getUser', 'getAccessFunctions', 'getCompanies']),
        async load(){
            this.auth = new Auth()
            if (!this.isSubtreeMode) {
                const query_str = new URLSearchParams({filter_by: JSON.stringify([
                    {member: 'type', operator: 'equals', values: [this.object_type]},
                    this.related_id_int != null ? {member: 'related_id_int', operator: 'equals', values: [this.related_id_int]} : null,
                    this.related_id_uuid != null ? {member: 'related_id_uuid', operator: 'equals', values: [this.related_id_uuid]} : null,
                ].filter(f => f != null))})
                const response = await this.auth.fetch('security/object/' + '?' + query_str, {method:  'GET',})
                this.object = (await response.json())[0]
            }
            // # All at the same time
            const tasks = [this.getRoles(), this.getUsers(), this.getAccessFunctions()]
            if (this.user.is_superuser || this.user.is_company_admin) {
                tasks.push(this.getCompanies())
            }
            await Promise.all(tasks)
        },
        close(){
            this.is_open = false
        },
        async open(){
            this.object = null
            this.object_loading = true
            this.company_filter = null
            this.share_targets = null
            this.is_open = true
            await this.load()
            this.object_loading = false
        },
        async fetchObjectRecord(node){
            const query_str = new URLSearchParams({filter_by: JSON.stringify([
                {member: 'type', operator: 'equals', values: [node.object_type]},
                node.related_id_int != null ? {member: 'related_id_int', operator: 'equals', values: [node.related_id_int]} : null,
                node.related_id_uuid != null ? {member: 'related_id_uuid', operator: 'equals', values: [node.related_id_uuid]} : null,
            ].filter(f => f != null))})
            const response = await this.auth.fetch('security/object/' + '?' + query_str, {method: 'GET'})
            const data = await response.json()
            return data[0]
        },
        async postShare(){
            this.share_loading = true
            const targets = this.parsedTargets
            try {
                if (this.isSubtreeMode) {
                    for (const node of this.nodes) {
                        const objectRecord = await this.fetchObjectRecord(node)
                        if (!objectRecord) continue
                        const access = node.object_type === 6 ? 'e' : this.access
                        for (const target of targets) {
                            await this.auth.fetch('security/object_access/', {method: 'POST', body: JSON.stringify({
                                object_id: objectRecord.id,
                                access,
                                role_id: target.type == 'role' ? target.id : null,
                                user_id: target.type == 'user' ? target.id : null,
                            })})
                        }
                    }
                } else {
                    for (const target of targets) {
                        await this.auth.fetch('security/object_access/', {method: 'POST', body: JSON.stringify({
                            object_id: this.object.id,
                            access: this.access,
                            role_id: target.type == 'role' ? target.id : null,
                            user_id: target.type == 'user' ? target.id : null,
                        })})
                    }
                }
            } finally {
                this.share_loading = false
                this.share_targets = null
            }
        },

        redirectManage(){
            // top.window.location.href = "/apps/ObjectAccess/?" + new URLSearchParams({
            //     filters: JSON.stringify([{member:'object_id', operator: 'equals', values: [this.object.id]}]),
            //     subtitle: `Access to ${this.object.type_name}: ${this.object.name}`
            // }).toString()
            this.$router.push({
                path: '/apps/ObjectAccess/',
                query: {
                    filters: JSON.stringify([{member:'object_id', operator: 'equals', values: [this.object.id]}]),
                    subtitle: `Access to ${this.object.type_name}: ${this.object.name}`
                }
            })

        },
        redirectObject(){
            // top.window.location.href = "/apps/ObjectTable/?" + new URLSearchParams({
            //     filters: JSON.stringify({id: this.object.id}),
            //     subtitle: `Object to ${this.object.type_name}: ${this.object.name}`
            // }).toString()
            this.$router.push({
                path: '/apps/ObjectTable/',
                query: {
                    filters: JSON.stringify([{member:'id', operator: 'equals', values: [this.object.id]}]),
                    subtitle: `Object to ${this.object.type_name}: ${this.object.name}`
                }
            })
        }
    },
    computed: {
        ...mapGetters(['roles','users', 'user', 'accessFunctions', 'companies']),
        canFilterByCompany(){
            return (this.user.is_superuser || this.user.is_company_admin) && this.companies.length > 1
        },
        companyOptions(){
            return [{value: null, label: 'All companies'}]
                .concat(this.companies.map(company => {return {value: company.id, label: company.name}}))
        },
        filteredUsers(){
            if (this.company_filter == null) return this.users
            return this.users.filter(user => user.company_id == this.company_filter)
        },
        shareOptions(){
            return this.accessFunctions.map(func => {return {value:{type:'function', 'id': func.id}, label: `Function: ${func.name}`}})
                .concat(this.roles.map(role => {return {value:{type:'role', 'id': role.id}, label: `Role: ${role.name}`}}))
                .concat(this.filteredUsers.map(user => {return {value:{type:'user', 'id': user.id}, label: `User: ${user.username}`}}))

        },
        canShare(){
            if (this.isSubtreeMode) return true
            if (this.user.is_superuser) return true
            if (this.user.is_company_admin) {
                const owner = this.users.filter(user => user.id == this.object.owner_id)[0]
                if (owner ){ // If can find the owners user object
                    return true
                }
            }
            return this.object && this.object.owner_id == this.user.id
        },
        isSubtreeMode(){
            return this.nodes != null
        },
        parsedTargets(){
            try {
                return JSON.parse(this.share_targets || '[]')
            } catch (e) {
                return []
            }
        },
        hasTargets(){
            return this.parsedTargets.length > 0
        },
        displayedAccessOptions(){
            return this.isSubtreeMode ? ['w','r'] : this.allowed_access
        }
    },
}

</script>